import { useState } from "react";
import apiService from "@/app/services/apiService";
import { UserDataModalProps, FormData } from "@/types/type";

export default function UserDataModal({ isOpen, onClose, user, refreshUserData }: UserDataModalProps) {
  const [formData, setFormData] = useState<FormData>({
    full_name: user.full_name || "",
    name: user.name || "",
    city: user.city || "",
    place: user.place || "",
    address: user.address || "",
    cpf_cnpj: user.cpf_cnpj || "",
    email: user.email || "",

  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name in formData) {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async () => {
    setLoading(true);
    setError(null);
    try {
      await apiService.postWithToken("/api/user/update_profile/", formData);
      refreshUserData();
      onClose();
    } catch (err) {
      console.error("Erro ao atualizar dados:", err);
      setError("Erro ao salvar. Tente novamente.");
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50">
      <div className="bg-white p-6 rounded-xl w-96 shadow-lg">
        <h2 className="text-xl text-center font-bold mb-4">Enviar dados</h2>

        {error && <p className="text-red-500 text-sm mb-2">{error}</p>}

        {(Object.entries({
          full_name: "Nome Completo",
          name: "Apelido",
          city: "Cidade",
          place: "Local",
          address: "Endereço",
          cpf_cnpj: "CPF/CNPJ",
          email: "Email"
        }) as [keyof FormData, string][]).map(([field, label]) => (
          <input
            key={field}
            name={field}
            value={formData[field]}
            onChange={handleChange}
            placeholder={label}
            className="mb-2 w-full p-2 border rounded text-sm"
            type={field === 'email' ? 'email' : 'text'}
          />
        ))}

        <button
          onClick={handleSubmit}
          disabled={loading}
          className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded w-full mt-2"
        >
          {loading ? "Salvando..." : "Salvar"}
        </button>
        <button
          onClick={onClose}
          className="text-gray-500 hover:underline w-full mt-2 text-sm"
        >
          Cancelar
        </button>
      </div>
    </div>
  );
}
